var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.707.294a.998.998 0 00-1.415 0l-6 6a1.001 1.001 0 001.415 1.414L11 3.415V23a1 1 0 102 0V3.415l4.293 4.293a1 1 0 101.415-1.414l-6-6z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconArrowUp;